import React, { useRef } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatModal from '../components/ChatModal';
import BannerCarros from '../assets/Banner-Carros.png';
import iconTema from '../assets/icon-Tema.png'

const CarroPage = () => {
  const chatModalRef = useRef(null);

  const handleOpenChat = () => {
    if (chatModalRef.current) {
      chatModalRef.current.openModal();
    }
  };
  return (
    <div>
      <Header onOpenChat={handleOpenChat} />
      
      {/* Hero Section */}
      <section className="relative gradient-bg text-white section-padding pt-26 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-20">
          <img 
            src="https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2083&q=80" 
            alt="Modern Car"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-somax-green/80 via-somax-green/70 to-somax-dark/90"></div>
        </div>
        
        <div className="absolute top-20 right-20 w-20 h-20 border-2 border-somax-yellow/30 rounded-full floating-animation"></div>
        <div className="absolute bottom-32 left-10 w-12 h-12 bg-somax-yellow/20 rounded-lg rotate-45 floating-animation" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-40 left-1/4 w-6 h-6 bg-white/30 rounded-full floating-animation" style={{animationDelay: '2s'}}></div>
        
        <div className="container-custom relative ">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-last lg:order-first md:mt-0 mt-[-120px] z-10">
              <div className="inline-block p-3 bg-somax-yellow/20 rounded-2xl mb-6 backdrop-blur-sm">
               <img 
                 src={iconTema}
                 alt="Dream Home"
                  className="w-12 h-12 rounded-lg"
                />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6 text-shadow-lg glow-text">
                Você não compra um carro, você compra <span className="text-somax-yellow bg-gradient-to-r from-somax-yellow to-yellow-300 bg-clip-text text-transparent">LIBERDADE</span>
              </h1>
              <p className="text-xl mb-8 text-somax-light leading-relaxed">
                Pare de depender de outros. Conquiste sua independência com o consórcio de carros Somax. 
                <span className="font-semibold text-somax-yellow"> Parcelas a partir de R$ 200/mês.</span>
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={handleOpenChat}
                  className="btn-secondary text-lg px-8 py-4 bg-gradient-to-r from-somax-yellow to-yellow-500 hover:from-yellow-500 hover:to-somax-yellow transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-somax-yellow/25"
                >
                  <span className="flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    Quero Meu Carro Agora!
                  </span>
                </button>
                <div className="text-somax-yellow font-bold text-lg flex items-center bg-white/10 px-4 py-2 rounded-lg backdrop-blur-sm border border-somax-yellow/30">
                  <span className="animate-pulse mr-2">⚡</span> Últimas 5 vagas disponíveis!
                </div>
              </div>
            </div>
            <div className="order-first lg:order-last">
              <img 
                src={BannerCarros}
                alt="Banner Carros Somax"
                className="w-full h-full object-cover transition-all duration-500 ease-in-out group-hover:scale-110 group-hover:rotate-1 group-hover:brightness-110"
              />
              {/* Overlay com efeito hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-somax-green/20 via-transparent to-somax-yellow/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              {/* Elementos flutuantes animados apenas no hover */}
              <div className="absolute top-4 right-4 w-16 h-16 border-2 border-somax-yellow/50 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-pulse transition-all duration-500"></div>
              <div className="absolute bottom-4 left-4 w-12 h-12 bg-somax-yellow/30 rounded-lg rotate-45 opacity-0 group-hover:opacity-100 group-hover:animate-bounce transition-all duration-500" style={{animationDelay: '0.5s'}}></div>
              <div className="absolute top-1/2 left-8 w-8 h-8 bg-white/40 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping transition-all duration-500" style={{animationDelay: '1s'}}></div>
            </div>
          </div>
        </div>
      </section>

      {/* Pain Points Section */}
      <section className="relative section-padding bg-gradient-to-br from-red-50 to-red-100 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <img 
            src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2006&q=80" 
            alt="Traffic Problems"
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Floating Warning Elements */}
        <div className="absolute top-10 right-10 w-16 h-16 border-2 border-red-300/40 rounded-full floating-animation"></div>
        <div className="absolute bottom-20 left-20 w-8 h-8 bg-red-200/30 rounded-lg rotate-45 floating-animation" style={{animationDelay: '1.5s'}}></div>
        
        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block p-4 bg-red-100/80 rounded-3xl mb-6 backdrop-blur-sm border border-red-200/50">
              <img 
                 src={iconTema}
                 alt="Dream Home"
                  className="w-12 h-12 rounded-lg"
                />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-red-600 mb-4 glow-text">
              Cansado dessas situações?
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="group bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-xl border-l-4 border-red-500 hover:shadow-2xl hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4 group-hover:scale-110 transition-transform duration-300">😤</div>
              <h3 className="text-xl font-bold text-red-600 mb-2 group-hover:text-red-700 transition-colors duration-300">Depender de Outros</h3>
              <p className="text-gray-600 leading-relaxed">Pedir carona, esperar ônibus lotado, chegar atrasado nos compromissos...</p>
              <div className="mt-4 h-1 bg-red-100 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-red-500 to-red-600 w-3/4 rounded-full group-hover:w-full transition-all duration-500"></div>
              </div>
            </div>
            
            <div className="group bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-xl border-l-4 border-red-500 hover:shadow-2xl hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4 group-hover:scale-110 transition-transform duration-300">💸</div>
              <h3 className="text-xl font-bold text-red-600 mb-2 group-hover:text-red-700 transition-colors duration-300">Gastar com Uber</h3>
              <p className="text-gray-600 leading-relaxed">R$ 20 aqui, R$ 30 ali... No final do mês gastou mais que uma parcela de carro!</p>
              <div className="mt-4 h-1 bg-red-100 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-red-500 to-red-600 w-4/5 rounded-full group-hover:w-full transition-all duration-500"></div>
              </div>
            </div>
            
            <div className="group bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-xl border-l-4 border-red-500 hover:shadow-2xl hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4 group-hover:scale-110 transition-transform duration-300">⏰</div>
              <h3 className="text-xl font-bold text-red-600 mb-2 group-hover:text-red-700 transition-colors duration-300">Perder Oportunidades</h3>
              <p className="text-gray-600 leading-relaxed">Aquela vaga de emprego longe, o encontro que não rolou, a família que não visitou...</p>
              <div className="mt-4 h-1 bg-red-100 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-red-500 to-red-600 w-5/6 rounded-full group-hover:w-full transition-all duration-500"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="relative section-padding bg-somax-light">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-somax-dark mb-4">
              A solução está aqui: <span className="text-gradient">Consórcio Somax</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Não é só um carro, é sua porta de entrada para uma vida melhor
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-somax-green rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-somax-dark mb-2">Liberdade Total</h3>
                    <p className="text-gray-600">Vá onde quiser, quando quiser. Sem depender de ninguém.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-somax-yellow rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-somax-dark font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-somax-dark mb-2">Economia Real</h3>
                    <p className="text-gray-600">Pare de gastar com transporte. Invista no seu patrimônio.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-somax-gray rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-somax-dark mb-2">Novas Oportunidades</h3>
                    <p className="text-gray-600">Trabalhe como motorista, faça entregas, expanda seus horizontes.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-lg shadow-xl">
              <h3 className="text-2xl font-bold text-somax-dark mb-6 text-center">Simulação Rápida</h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-somax-light rounded-lg">
                  <span className="font-medium">Carro Popular</span>
                  <span className="text-somax-green font-bold">R$ 200/mês</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-somax-light rounded-lg">
                  <span className="font-medium">Carro Médio</span>
                  <span className="text-somax-green font-bold">R$ 350/mês</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-somax-light rounded-lg">
                  <span className="font-medium">SUV/Pickup</span>
                  <span className="text-somax-green font-bold">R$ 500/mês</span>
                </div>
              </div>
              <button 
                onClick={handleOpenChat}
                className="btn-primary w-full mt-6"
              >
                Calcular Minha Parcela
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="relative section-padding bg-gradient-to-br from-white to-gray-50 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <img 
            src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2126&q=80" 
            alt="Success Pattern"
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Floating Success Elements */}
        <div className="absolute top-20 left-20 w-12 h-12 bg-somax-green/20 rounded-full floating-animation"></div>
        <div className="absolute bottom-32 right-32 w-8 h-8 border-2 border-somax-yellow/30 rounded-lg rotate-45 floating-animation" style={{animationDelay: '2s'}}></div>
        
        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block p-4 bg-somax-green/10 rounded-3xl mb-6 backdrop-blur-sm border border-somax-green/20">
             <img 
                 src={iconTema}
                 alt="Dream Home"
                  className="w-12 h-12 rounded-lg"
                />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-somax-dark mb-4 glow-text">
              Mais de <span className="text-somax-green bg-gradient-to-r from-somax-green to-somax-green/80 bg-clip-text text-transparent">5.000 clientes</span> já conquistaram seus carros
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="group bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 border border-somax-green/10">
              <div className="flex items-center mb-4">
                <div className="relative">
                  <div className="w-12 h-12 bg-gradient-to-br from-somax-green to-somax-green/80 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-white font-bold">M</span>
                  </div>
                  <div className="absolute -top-1 -right-1 w-4 h-4 bg-somax-yellow rounded-full opacity-80"></div>
                </div>
                <div>
                  <h4 className="font-bold text-somax-dark group-hover:text-somax-green transition-colors duration-300">Maria Silva</h4>
                  <p className="text-gray-600 text-sm">São Paulo, SP</p>
                </div>
              </div>
              <p className="text-gray-700 italic leading-relaxed mb-4">
                "Finalmente consegui meu carro! Agora posso trabalhar como motorista de app e triplicar minha renda. A Somax mudou minha vida!"
              </p>
              <div className="flex text-somax-yellow text-lg">
                ⭐⭐⭐⭐⭐
              </div>
              <div className="mt-4 h-1 bg-gray-100 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-somax-green to-somax-green/80 w-full rounded-full"></div>
              </div>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 border border-somax-yellow/10">
              <div className="flex items-center mb-4">
                <div className="relative">
                  <div className="w-12 h-12 bg-gradient-to-br from-somax-yellow to-yellow-600 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-somax-dark font-bold">J</span>
                  </div>
                  <div className="absolute -top-1 -right-1 w-4 h-4 bg-somax-green rounded-full opacity-80"></div>
                </div>
                <div>
                  <h4 className="font-bold text-somax-dark group-hover:text-somax-yellow transition-colors duration-300">João Santos</h4>
                  <p className="text-gray-600 text-sm">Rio de Janeiro, RJ</p>
                </div>
              </div>
              <p className="text-gray-700 italic leading-relaxed mb-4">
                "Processo super rápido! Em 15 dias já estava com meu carro 0km. Parcela de R$ 280 que cabe perfeitamente no meu orçamento."
              </p>
              <div className="flex text-somax-yellow text-lg">
                ⭐⭐⭐⭐⭐
              </div>
              <div className="mt-4 h-1 bg-gray-100 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-somax-yellow to-yellow-600 w-full rounded-full"></div>
              </div>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 border border-somax-gray/10">
              <div className="flex items-center mb-4">
                <div className="relative">
                  <div className="w-12 h-12 bg-gradient-to-br from-somax-gray to-gray-600 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-white font-bold">A</span>
                  </div>
                  <div className="absolute -top-1 -right-1 w-4 h-4 bg-somax-yellow rounded-full opacity-80"></div>
                </div>
                <div>
                  <h4 className="font-bold text-somax-dark group-hover:text-somax-gray transition-colors duration-300">Ana Costa</h4>
                  <p className="text-gray-600 text-sm">Belo Horizonte, MG</p>
                </div>
              </div>
              <p className="text-gray-700 italic leading-relaxed mb-4">
                "Estava gastando R$ 400/mês com Uber. Agora pago R$ 320 de parcela e o carro é MEU! Melhor decisão que já tomei."
              </p>
              <div className="flex text-somax-yellow text-lg">
                ⭐⭐⭐⭐⭐
              </div>
              <div className="mt-4 h-1 bg-gray-100 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-somax-gray to-gray-600 w-full rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Urgency Section */}
      <section className="section-padding bg-red-600 text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            ⚠️ ATENÇÃO: Oferta por tempo limitado!
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Apenas <strong>5 vagas restantes</strong> para o grupo que inicia em Janeiro/2024. 
            Não perca esta oportunidade única!
          </p>
          
          <div className="bg-white text-red-600 p-6 rounded-lg inline-block mb-8">
            <div className="text-3xl font-bold mb-2">Taxa ZERO</div>
            <div className="text-lg">Para os próximos 5 aprovados</div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={handleOpenChat}
              className="bg-somax-yellow hover:bg-yellow-500 text-somax-dark font-bold py-4 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 text-lg"
            >
              Garantir Minha Vaga Agora!
            </button>
          </div>
        </div>
      </section>

      <Footer />
      <ChatModal ref={chatModalRef} />
    </div>
  );
};

export default CarroPage;